import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.management.qna');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type ConsultationSource = 'WOONGBIN_MINI';
type ConsultationStatus =
    | 'RECEIVED'
    | 'ASSIGNED'
    | 'IN_PROGRESS'
    | 'ON_HOLD'
    | 'COMPLETED'
    | 'CANCELLED';
type MessageVisibility = 'INTERNAL' | 'PUBLIC';
type DetailTab = 'overview' | 'handling' | 'documents';

type Requester = {
    office_name: string;
    name: string;
    phone: string;
    email: string;
};

type ConsultationListItem = {
    id: string;
    source: ConsultationSource;
    category: string;
    subject: string;
    requester: Requester;
    privacy_consent: boolean;
    status: ConsultationStatus;
    assigned_to: string | null;
    created_at: string;
    updated_at: string;
    body_preview: string;
};

type StatusHistory = {
    id: string;
    from_status: ConsultationStatus | null;
    to_status: ConsultationStatus;
    changed_by: string;
    reason: string;
    created_at: string;
};

type ConsultationMessage = {
    id: string;
    body: string;
    visibility: MessageVisibility;
    created_by: string;
    created_at: string;
};

type ConsultationDetail = ConsultationListItem & {
    body: string;
    status_history: StatusHistory[];
    messages: ConsultationMessage[];
    audit_events: any[];
};

type Pagination = {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
};

@Component({
    selector: 'wiz-page-ip-management-qna',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.management.qna/view.scss */
:host {
  display: block;
  height: 100%;
}

.ipm-qna-modal-backdrop {
  position: fixed;
  z-index: 90;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: rgba(9, 30, 20, 0.56);
  cursor: default;
}

.ipm-qna-modal-backdrop:disabled {
  cursor: wait;
}

.ipm-qna-modal {
  position: fixed;
  z-index: 100;
  top: 50%;
  left: 50%;
  display: flex;
  width: min(72rem, 100vw - 2rem);
  height: min(52rem, 100vh - 2rem);
  height: min(52rem, 100dvh - 2rem);
  max-width: none;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  transform: translate(-50%, -50%);
  border: 1px solid #dce7e0;
  border-radius: 1rem;
  color: #10241a;
  background: #fff;
  box-shadow: 0 30px 90px rgba(7, 29, 18, 0.28);
  animation: ipm-qna-modal-enter 180ms ease-out both;
  overscroll-behavior: contain;
}

.ipm-qna-modal-header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.1rem;
  border-bottom: 1px solid #dce7e0;
  background: #fff;
}

.ipm-qna-status-control {
  display: grid;
  width: min(31rem, 48%);
  flex: 0 0 auto;
  grid-template-columns: 7.5rem minmax(8rem, 1fr) auto;
  gap: 0.45rem;
}

.ipm-qna-tabs {
  display: grid;
  flex: 0 0 auto;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.4rem;
  padding: 0.55rem 0.7rem;
  border-bottom: 1px solid #dce7e0;
  background: #f5f8f6;
}

.ipm-qna-tabs button {
  display: flex;
  min-width: 0;
  min-height: 3rem;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 0.55rem 0.75rem;
  border: 1px solid transparent;
  border-radius: 0.7rem;
  color: #65766d;
  background: transparent;
  font-size: 0.75rem;
  font-weight: 750;
  transition: border-color 150ms ease, color 150ms ease, background-color 150ms ease, box-shadow 150ms ease;
}

.ipm-qna-tabs button:hover {
  border-color: #c7d8ce;
  color: #0d5b34;
  background: #fff;
}

.ipm-qna-tabs button:focus-visible {
  outline: 2px solid rgba(25, 116, 67, 0.35);
  outline-offset: 1px;
}

.ipm-qna-tabs button.is-active {
  border-color: #abd2ba;
  color: #0d5b34;
  background: #fff;
  box-shadow: 0 6px 18px rgba(20, 96, 55, 0.08);
}

.ipm-qna-tab-step {
  display: inline-flex;
  width: 1.75rem;
  height: 1.75rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: #7d8d84;
  background: #e5ede8;
  font-size: 0.63rem;
  font-weight: 800;
}

.ipm-qna-tabs button.is-active .ipm-qna-tab-step {
  color: #fff;
  background: #197443;
}

.ipm-qna-modal-body {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1rem;
  background: #f7faf8;
  scrollbar-color: #bfd0c5 transparent;
  scrollbar-width: thin;
}

.ipm-qna-tab-panel[hidden] {
  display: none !important;
}

.ipm-qna-tab-panel {
  animation: ipm-qna-panel-enter 150ms ease-out both;
}

.ipm-qna-panel-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.85rem;
  padding: 0.9rem 1rem;
  border: 1px solid #dce7e0;
  border-radius: 0.85rem;
  background: #fff;
}

.ipm-qna-panel-heading h3 {
  margin-top: 0.15rem;
  color: #10241a;
  font-size: 0.92rem;
  font-weight: 800;
}

.ipm-qna-eyebrow {
  color: #197443;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.ipm-qna-panel-chip {
  max-width: 24rem;
  overflow: hidden;
  padding: 0.3rem 0.6rem;
  border: 1px solid #c9dfd0;
  border-radius: 999px;
  color: #0d5b34;
  background: #eff8f2;
  font-size: 0.65rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ipm-qna-card {
  min-width: 0;
  padding: 1rem;
  border: 1px solid #dce7e0;
  border-radius: 0.85rem;
  background: #fff;
  box-shadow: 0 8px 24px rgba(18, 50, 33, 0.04);
}

.ipm-qna-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.ipm-qna-info-grid > div {
  min-width: 0;
  padding: 0.7rem;
  border-radius: 0.65rem;
  background: #f7faf8;
}

.ipm-qna-info-grid dt {
  color: #84938b;
  font-size: 0.67rem;
}

.ipm-qna-info-grid dd {
  margin-top: 0.25rem;
  overflow-wrap: anywhere;
  color: #263a2f;
  font-size: 0.75rem;
  font-weight: 650;
}

.ipm-qna-message-toggle {
  display: inline-flex;
  padding: 0.2rem;
  border: 1px solid #dce7e0;
  border-radius: 0.65rem;
  background: #f5f8f6;
}

.ipm-qna-message-toggle button {
  min-height: 1.9rem;
  padding: 0.3rem 0.65rem;
  border-radius: 0.45rem;
  color: #65766d;
  font-size: 0.65rem;
  font-weight: 700;
}

.ipm-qna-message-toggle button.is-active {
  color: #0d5b34;
  background: #fff;
  box-shadow: 0 2px 8px rgba(18, 50, 33, 0.08);
}

@keyframes ipm-qna-modal-enter {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-50% + 0.75rem)) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
@keyframes ipm-qna-panel-enter {
  from {
    opacity: 0;
    transform: translateY(0.2rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 960px) {
  .ipm-qna-modal {
    width: calc(100vw - 1rem);
    height: calc(100vh - 1rem);
    height: calc(100dvh - 1rem);
    border-radius: 0.85rem;
  }
  .ipm-qna-modal-header {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .ipm-qna-status-control {
    width: calc(100% - 4.5rem);
    flex: 1 1 auto;
  }
}
@media (max-width: 640px) {
  .ipm-qna-modal-header {
    gap: 0.65rem;
    padding: 0.85rem;
  }
  .ipm-qna-status-control {
    width: 100%;
    order: 3;
    grid-template-columns: 1fr auto;
  }
  .ipm-qna-status-control input {
    grid-column: 1/-1;
    grid-row: 2;
  }
  .ipm-qna-tabs {
    gap: 0.25rem;
    padding: 0.4rem;
  }
  .ipm-qna-tabs button {
    min-height: 3.5rem;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.4rem 0.25rem;
    font-size: 0.62rem;
    line-height: 0.9rem;
    text-align: center;
  }
  .ipm-qna-tab-step {
    width: 1.4rem;
    height: 1.4rem;
    font-size: 0.55rem;
  }
  .ipm-qna-modal-body {
    padding: 0.65rem;
  }
  .ipm-qna-panel-heading {
    align-items: flex-start;
    padding: 0.75rem;
  }
  .ipm-qna-panel-chip {
    max-width: 45%;
  }
  .ipm-qna-info-grid {
    grid-template-columns: 1fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  .ipm-qna-modal,
  .ipm-qna-tab-panel {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
  }
}`],
})
export class PageIpManagementQnaComponent implements OnInit {
    public statuses: ConsultationStatus[] = [
        'RECEIVED',
        'ASSIGNED',
        'IN_PROGRESS',
        'ON_HOLD',
        'COMPLETED',
        'CANCELLED'
    ];
    public filters: any = {
        status: '',
        category: '',
        assigned_to: '',
        q: '',
        page: 1,
        limit: 20
    };
    public items: ConsultationListItem[] = [];
    public pagination: Pagination = { page: 1, limit: 20, total: 0, total_pages: 1 };
    public selected: ConsultationDetail | null = null;
    public detailOpen: boolean = false;
    public activeDetailTab: DetailTab = 'overview';
    public loading: boolean = false;
    public detailLoading: boolean = false;
    public saving: boolean = false;
    public errorMessage: string = '';
    public assigneeDraft: string = '';
    public statusDraft: ConsultationStatus = 'RECEIVED';
    public statusReason: string = '';
    public messageDraft: string = '';
    public messageVisibility: MessageVisibility = 'INTERNAL';
    public documentSubject: string = '';
    public documentMessage: string = '';
    public documentFiles: File[] = [];
    public dispatchHistory: any[] = [];
    public dispatchSending: boolean = false;
    public dispatchLoading: boolean = false;
    public uploadProgress: number = 0;
    private detailSequence: number = 0;
    private readonly maxDocumentFiles: number = 5;
    private readonly maxDocumentFileSize: number = 20 * 1024 * 1024;
    private readonly maxDocumentTotalSize: number = 40 * 1024 * 1024;
    private readonly allowedDocumentExtensions: string[] = [
        '.pdf', '.hwp', '.hwpx', '.doc', '.docx', '.xls', '.xlsx',
        '.ppt', '.pptx', '.txt', '.csv', '.zip', '.jpg', '.jpeg', '.png'
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public async load(resetPage: boolean = false) {
        if (this.loading) return;
        if (resetPage) this.filters.page = 1;

        const previousId = this.detailOpen ? this.selected?.id || '' : '';
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call('list_consultations', this.filters);
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '상담 목록을 불러오지 못했습니다.'));
            }
            const data = response.data || {};
            this.items = Array.isArray(data.items) ? data.items : [];
            this.pagination = data.pagination || {
                page: this.filters.page,
                limit: this.filters.limit,
                total: this.items.length,
                total_pages: 1
            };
            this.filters.page = this.pagination.page || 1;

            const next = previousId
                ? this.items.find((item) => item.id === previousId)
                : undefined;
            if (next) {
                await this.loadDetail(next.id, false, true);
            } else {
                this.selected = null;
                this.detailOpen = false;
            }
        } catch (error) {
            this.items = [];
            this.selected = null;
            this.detailOpen = false;
            this.errorMessage = this.errorText(error, '상담 목록을 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadDetail(id: string, render: boolean = true, preserveTab: boolean = false) {
        if (!id) return;
        const sequence = ++this.detailSequence;
        this.detailOpen = true;
        if (!preserveTab) this.activeDetailTab = 'overview';
        if (this.selected?.id !== id) this.selected = null;
        this.detailLoading = true;
        this.errorMessage = '';
        if (render) await this.service.render();

        try {
            const response = await wiz.call('get_consultation', { id });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '상담 상세를 불러오지 못했습니다.'));
            }
            if (sequence !== this.detailSequence) return;
            this.applyDetail(response.data as ConsultationDetail);
            await this.loadDispatchHistory(id, false);
        } catch (error) {
            if (sequence !== this.detailSequence) return;
            this.detailOpen = false;
            this.selected = null;
            this.errorMessage = this.errorText(error, '상담 상세를 불러오지 못했습니다.');
            if (render) await this.service.modal.error(this.errorMessage);
        } finally {
            if (sequence === this.detailSequence) {
                this.detailLoading = false;
                if (render) await this.service.render();
            }
        }
    }

    public async closeDetail() {
        if (this.saving || this.dispatchSending) return;
        this.detailSequence += 1;
        this.detailOpen = false;
        this.detailLoading = false;
        this.selected = null;
        this.activeDetailTab = 'overview';
        this.messageDraft = '';
        this.documentFiles = [];
        await this.service.render();
    }

    public async selectDetailTab(tab: DetailTab) {
        this.activeDetailTab = tab;
        await this.service.render();
    }

    public async setMessageVisibility(visibility: MessageVisibility) {
        this.messageVisibility = visibility;
        await this.service.render();
    }

    public get publicMessages() {
        return (this.selected?.messages || []).filter(
            (message) => message.visibility === 'PUBLIC'
        );
    }

    public get internalMessages() {
        return (this.selected?.messages || []).filter(
            (message) => message.visibility === 'INTERNAL'
        );
    }

    public get messagePlaceholder() {
        return this.messageVisibility === 'PUBLIC'
            ? '상담자에게 공개할 메시지를 입력하세요.'
            : '관리자만 확인할 내부메모를 입력하세요.';
    }

    public get messageActionLabel() {
        return this.messageVisibility === 'PUBLIC' ? '고객 메시지 추가' : '내부메모 추가';
    }

    public async assign() {
        if (!this.selected || this.saving) return;
        const assignee = this.assigneeDraft.trim();
        if (!assignee) {
            await this.service.modal.error('담당자 식별자를 입력해주세요.');
            return;
        }
        await this.mutate(
            'assign_consultation',
            { id: this.selected.id, assignee },
            '담당자가 배정되었습니다.',
            '담당자 배정에 실패했습니다.'
        );
    }

    public async updateStatus() {
        if (!this.selected || this.saving) return;
        if (this.statusDraft === this.selected.status) {
            await this.service.modal.error('현재 상태와 다른 상태를 선택해주세요.');
            return;
        }
        await this.mutate(
            'update_consultation_status',
            {
                id: this.selected.id,
                status: this.statusDraft,
                reason: this.statusReason.trim()
            },
            '상담 상태가 변경되었습니다.',
            '상담 상태 변경에 실패했습니다.'
        );
    }

    public async addMessage() {
        if (!this.selected || this.saving) return;
        const body = this.messageDraft.trim();
        if (!body) {
            await this.service.modal.error('메시지 내용을 입력해주세요.');
            return;
        }

        this.saving = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('add_consultation_message', {
                id: this.selected.id,
                body,
                visibility: this.messageVisibility
            });
            if (response.code !== 201) {
                throw new Error(this.responseError(response, '메시지 추가에 실패했습니다.'));
            }
            this.messageDraft = '';
            await this.loadDetail(this.selected.id, false, true);
            await this.service.modal.success('상담 메시지가 추가되었습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(error, '메시지 추가에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    private defaultDocumentSubject(detail: ConsultationDetail) {
        return '[웅빈] ' + detail.subject + ' 관련 서류';
    }

    private defaultDocumentMessage(detail: ConsultationDetail) {
        const name = detail.requester?.name || '고객';
        return name + '님 안녕하세요? 주식회사 웅빈입니다.\n\n'
            + '문의하신 상담 관련 서류를 첨부드립니다.\n'
            + '첨부파일을 확인해주시기 바랍니다. 감사합니다.';
    }

    public async loadDispatchHistory(id: string, render: boolean = true) {
        if (!id) return;
        this.dispatchLoading = true;
        if (render) await this.service.render();
        try {
            const response = await wiz.call('list_consultation_dispatches', { id });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '서류 발송 이력을 불러오지 못했습니다.'));
            }
            this.dispatchHistory = Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            this.dispatchHistory = [];
            this.errorMessage = this.errorText(error, '서류 발송 이력을 불러오지 못했습니다.');
        } finally {
            this.dispatchLoading = false;
            if (render) await this.service.render();
        }
    }

    public async selectDocumentFiles(event: any) {
        const files = Array.from(event?.target?.files || []) as File[];
        if (event?.target) event.target.value = '';
        const accepted: File[] = [];
        const rejected: string[] = [];
        let total = this.documentFiles.reduce((sum, file) => sum + file.size, 0);
        for (const file of files) {
            const dot = file.name.lastIndexOf('.');
            const extension = dot >= 0 ? file.name.slice(dot).toLowerCase() : '';
            if (!this.allowedDocumentExtensions.includes(extension)) {
                rejected.push(file.name + ': 지원하지 않는 형식');
                continue;
            }
            if (!file.size || file.size > this.maxDocumentFileSize) {
                rejected.push(file.name + ': 파일당 20MB 초과');
                continue;
            }
            if (this.documentFiles.length + accepted.length >= this.maxDocumentFiles) {
                rejected.push(file.name + ': 최대 5개 초과');
                continue;
            }
            if (total + file.size > this.maxDocumentTotalSize) {
                rejected.push(file.name + ': 전체 40MB 초과');
                continue;
            }
            accepted.push(file);
            total += file.size;
        }
        this.documentFiles = [...this.documentFiles, ...accepted];
        if (rejected.length) await this.service.modal.error(rejected.join('\n'));
        await this.service.render();
    }

    public async removeDocumentFile(index: number) {
        this.documentFiles.splice(index, 1);
        await this.service.render();
    }

    public async sendDocuments() {
        if (!this.selected || this.dispatchSending) return;
        if (!this.selected.requester?.email) {
            await this.service.modal.error('상담자의 이메일 주소가 없어 서류를 발송할 수 없습니다.');
            return;
        }
        if (!this.documentSubject.trim() || !this.documentMessage.trim()) {
            await this.service.modal.error('이메일 제목과 안내 문구를 입력해주세요.');
            return;
        }
        if (!this.documentFiles.length) {
            await this.service.modal.error('발송할 서류를 1개 이상 첨부해주세요.');
            return;
        }
        const confirmed = await this.service.modal.show({
            title: '상담 서류 발송',
            message: this.selected.requester.email + ' 주소로 첨부서류를 발송합니다.',
            action: '발송',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'success'
        });
        if (!confirmed) return;

        this.dispatchSending = true;
        this.uploadProgress = 0;
        await this.service.render();
        try {
            const form = new FormData();
            form.append('id', this.selected.id);
            form.append('subject', this.documentSubject.trim());
            form.append('message', this.documentMessage.trim());
            form.append('file_count', String(this.documentFiles.length));
            this.documentFiles.forEach((file, index) => form.append('file_' + index, file));
            const response: any = await this.service.file.upload(
                wiz.url('send_consultation_documents'),
                form,
                async (percent: number) => {
                    this.uploadProgress = percent;
                    await this.service.render();
                }
            );
            const payload = response?.responseJSON || response;
            const status = Number(payload?.code ?? response?.status ?? 500);
            if (status !== 201) {
                throw new Error(this.responseError(payload, '상담 서류를 발송하지 못했습니다.'));
            }
            const sent = payload?.data;
            this.dispatchHistory = sent ? [sent, ...this.dispatchHistory] : this.dispatchHistory;
            this.documentFiles = [];
            if (sent?.status === '발송완료') {
                await this.service.modal.success('상담 서류를 발송했습니다.');
            } else {
                await this.service.modal.show({
                    title: '발송대기',
                    message: '서류가 발송대기로 저장되었습니다. SMTP 설정을 확인해주세요.',
                    action: '확인',
                    cancel: false,
                    status: 'warning',
                    actionBtn: 'warning'
                });
            }
        } catch (error) {
            await this.service.modal.error(this.errorText(error, '상담 서류를 발송하지 못했습니다.'));
        } finally {
            this.dispatchSending = false;
            await this.service.render();
        }
    }

    public downloadDocument(dispatch: any, file: any) {
        const query = new URLSearchParams({
            id: this.selected?.id || '',
            dispatch_id: dispatch.id,
            file_id: file.id
        });
        window.open(
            wiz.url('download_consultation_document') + '?' + query.toString(),
            '_blank',
            'noopener,noreferrer'
        );
    }

    public formatFileSize(size: number) {
        const bytes = Number(size || 0);
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public dispatchStatusClass(status: string) {
        if (status === '발송완료') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === '발송실패') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-amber-200 bg-amber-50 text-amber-700';
    }

    public async previousPage() {
        if (this.loading || this.pagination.page <= 1) return;
        this.filters.page = this.pagination.page - 1;
        await this.load();
    }

    public get pageNumbers(): number[] {
        const total = Math.max(Number(this.pagination?.total_pages || 1), 1);
        return Array.from({ length: total }, (_, index) => index + 1);
    }

    public async goToPage(page: number) {
        if (this.loading) return;
        const total = Math.max(Number(this.pagination?.total_pages || 1), 1);
        this.filters.page = Math.min(Math.max(page, 1), total);
        await this.load();
    }

    public async nextPage() {
        if (this.loading || this.pagination.page >= this.pagination.total_pages) return;
        this.filters.page = this.pagination.page + 1;
        await this.load();
    }

    public sourceLabel(source: ConsultationSource) {
        return source === 'WOONGBIN_MINI' ? '웅빈 미니홈' : source;
    }

    public statusLabel(status: ConsultationStatus) {
        switch (status) {
            case 'RECEIVED': return '접수';
            case 'ASSIGNED': return '배정';
            case 'IN_PROGRESS': return '진행 중';
            case 'ON_HOLD': return '보류';
            case 'COMPLETED': return '완료';
            case 'CANCELLED': return '취소';
            default: return status;
        }
    }

    public statusClass(status: ConsultationStatus) {
        switch (status) {
            case 'RECEIVED': return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'ASSIGNED': return 'border-sky-200 bg-sky-50 text-sky-700';
            case 'IN_PROGRESS': return 'border-violet-200 bg-violet-50 text-violet-700';
            case 'COMPLETED': return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'CANCELLED': return 'border-rose-200 bg-rose-50 text-rose-700';
            default: return 'border-slate-200 bg-slate-100 text-slate-600';
        }
    }

    public sourceClass(source: ConsultationSource) {
        return source === 'WOONGBIN_MINI'
            ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
            : 'border-slate-200 bg-white text-slate-500';
    }

    public formatDate(value: string) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    }

    private async mutate(action: string, payload: any, success: string, fallback: string) {
        this.saving = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call(action, payload);
            if (response.code !== 200) {
                throw new Error(this.responseError(response, fallback));
            }
            this.applyDetail(response.data as ConsultationDetail);
            this.updateListItem(this.selected);
            await this.service.modal.success(success);
        } catch (error) {
            this.errorMessage = this.errorText(error, fallback);
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    private applyDetail(detail: ConsultationDetail) {
        const changed = this.selected?.id !== detail.id;
        detail.messages = Array.isArray(detail.messages) ? detail.messages : [];
        detail.status_history = Array.isArray(detail.status_history) ? detail.status_history : [];
        this.selected = detail;
        this.assigneeDraft = detail.assigned_to || '';
        this.statusDraft = detail.status;
        this.statusReason = '';
        if (changed) {
            this.documentSubject = this.defaultDocumentSubject(detail);
            this.documentMessage = this.defaultDocumentMessage(detail);
            this.documentFiles = [];
            this.dispatchHistory = [];
        }
    }

    private updateListItem(detail: ConsultationDetail | null) {
        if (!detail) return;
        const index = this.items.findIndex((item) => item.id === detail.id);
        if (index < 0) return;
        this.items[index] = {
            ...this.items[index],
            source: detail.source,
            category: detail.category,
            subject: detail.subject,
            requester: detail.requester,
            privacy_consent: detail.privacy_consent,
            status: detail.status,
            assigned_to: detail.assigned_to,
            created_at: detail.created_at,
            updated_at: detail.updated_at,
            body_preview: detail.body
        };
    }

    private responseError(response: any, fallback: string) {
        const error = response?.data?.error;
        if (!error) return fallback;
        const messages: any = {
            CORE_API_PROXY_NOT_CONFIGURED: 'Core API 연동 설정이 필요합니다',
            CORE_API_UNAVAILABLE: 'Core API에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.',
            UNAUTHORIZED: 'Core API 관리자 토큰을 확인해주세요.',
            ADMIN_AUTH_NOT_CONFIGURED: 'Core API 관리자 인증이 설정되지 않았습니다.',
            CONSULTATION_NOT_FOUND: '선택한 상담을 찾을 수 없습니다.',
            INVALID_STATUS: '변경할 상담 상태를 확인해주세요.',
            INVALID_VISIBILITY: '메시지 공개 범위를 확인해주세요.'
        };
        return messages[error.code] || error.message || fallback;
    }

    private errorText(error: any, fallback: string) {
        return error instanceof Error && error.message ? error.message : fallback;
    }
}

export default PageIpManagementQnaComponent;